import RequiredMark from "../RequiredMark"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import React from "react"
const RequiredHeader = <T extends any>(
  props: React.ComponentProps<typeof wjrGrid.FlexGridCellTemplate>
) => {
  return (
    <wjrGrid.FlexGridCellTemplate
      cellType="ColumnHeader"
      template={(context: TWijmoCellTemplateContext<T>) => {
        return (
          <>
            <span>{context.col.header}</span>
            <RequiredMark />
          </>
        )
      }}
      {...props}></wjrGrid.FlexGridCellTemplate>
  )
}

export default RequiredHeader
